import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { makeStyles, Modal, Button, Grid } from '@material-ui/core';

import TextField from '@material-ui/core/TextField';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    backdropFilter: "blur(3px)",
  },
  container: {
    margin: theme.spacing(1),
  }
}));

//
const ItemModal = forwardRef((props, ref) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [quantity, setQuantity] = useState(1);

  useImperativeHandle(ref, () => ({
    handleOpen() {
      setOpen(true);
      setName("")
      setDescription("")
      setWeight(0)
      setQuantity(1)
    }
  }))

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.handleAddItem(name, description, weight, quantity)
    handleClose()
  }

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <form style={modalStyle} className={classes.paper}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            spacing={3}
          >
            <TextField item required label="Nome" onChange={(e) => { setName(e.target.value) }} />
            <TextField item required label="Descrição" onChange={(e) => { setDescription(e.target.value) }} />
            <TextField item required label="Peso" type="number" onChange={(e) => { setWeight(e.target.value) }} />
            <TextField item required defaultValue={1} label="Quantidade" type="number" onChange={(e) => { setQuantity(e.target.value) }} />
            <Button item type="submit" onClick={handleSubmit}>Adicionar</Button>
          </Grid>
        </form>
      </Modal>

    </React.Fragment>
  );
})

export default ItemModal;